import React from 'react';
import CopyLinkButton from './CopyLinkButton';
import { publicUrl, prettyUrl } from './publicUrl';

/**
 * One public-surface link: label, the URL as an openable link, and a Copy button.
 *
 * Takes a PATH, never a host — the host is `publicUrl`'s job, and routing it
 * through here is what stops a caller re-introducing a literal. The href carries
 * the scheme (a browser needs it) while the visible text drops it (a human
 * reading a URL on a card does not want it), so the two are the same URL in two
 * registers, both derived from the live origin.
 */
export default function PublicLinkRow({ label, path }) {
  const href = publicUrl(path);
  return (
    <div className="lty-link-preview lty-link-actionrow" style={{ marginTop: 8 }}>
      <span className="lty-link-actionrow-text">
        {label}:{' '}
        {/* noopener/noreferrer: this opens on a shared venue tablet. */}
        <a href={href} target="_blank" rel="noopener noreferrer" className="lty-link-a">
          <b>{prettyUrl(path)}</b>
        </a>
      </span>
      <CopyLinkButton value={href} label={label} />
    </div>
  );
}
